import React, { useEffect, useState, useRef } from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);
  return <section id={id} ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'} ${className}`} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-223">
      {children}
    </section>;
}